'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createLazyPropType;

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createLazyPropType(rawPropType) {
  var propTypeWithFuncEval = function propTypeWithFuncEval(props, propName) {
    for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    var value = props[propName];
    if (!value) {
      return null;
    }

    // If the value is not a function, check that it satisfies rawPropType
    if (typeof value !== 'function') {
      return rawPropType.apply(undefined, [props, propName].concat(rest));
    }

    // Check that the value returned by the function satisfies rawPropType
    var modifiedProps = _extends({}, props);
    modifiedProps[propName] = value();
    return rawPropType.apply(undefined, [modifiedProps, propName].concat(rest));
  };

  // Name this propType "lazyX", where "X" is the name of the raw prop type
  var rawPropTypeName = rawPropType.__INTROSPECTION__ ? rawPropType.__INTROSPECTION__.type : 'value';
  var lazyPropTypeName = 'lazy' + (rawPropTypeName.charAt(0).toUpperCase() + rawPropTypeName.slice(1));
  var chainablePropType = (0, _createChainablePropType2.default)(propTypeWithFuncEval, lazyPropTypeName);

  return chainablePropType;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/utils/propTypes/createLazyPropType.js
// module id = 101
// module chunks = 3 4 5